import { useParams } from "react-router-dom";
import { useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { entityService } from "@/services/breeze/EntityService";
import { IEntity } from "@/types/breeze/Entity";
import EntityForm, { EntityFormHandle } from "@/components/entity/EntityFormV2";
import { singularize, formatAnyName } from "@/utils/text";
import PageTemplate from "@/components/page-template/PageTemplate";
import { LoadingScreen } from "@/components/ui/LoadingScreen";
import ErrorScreen from "@/components/ui/ErrorCard";
import { Button } from "@radix-ui/themes";

export default function CreateEntityPage() {
  const params = useParams();
  const entityName = params.entityName as string;
  const formRef = useRef<EntityFormHandle>(null);
  const [isSaving, setIsSaving] = useState(false);

  const { data: entity, isLoading } = useQuery<IEntity>({
    queryKey: ["entity", entityName],
    queryFn: () => entityService.getByName(entityName),
  });

  const handleCreateClick = () => {
    formRef.current?.saveChanges();
  };

  if (isLoading) return <LoadingScreen fullPage={false} />;
  if (!entity) return <ErrorScreen error="Entity not found" />;

  const createButton = (
    <Button
      onClick={handleCreateClick}
      style={{ minWidth: "8rem" }}
      loading={isSaving}
    >
      Create {singularize(formatAnyName(entity.name))}
    </Button>
  );

  return (
    <PageTemplate
      title={`Create New ${singularize(formatAnyName(entity.name))}`}
      rightContent={createButton}
    >
      <EntityForm
        ref={formRef}
        entity={entity}
        mode="create"
        userHasUpdatePermission={false}
        onLoadingStateChange={setIsSaving}
      />
    </PageTemplate>
  );
}
